/**
 * List of current AB Tests
 * @param {object} options
 * @param {object} options.customer
 * @param {object} options.order
 * @param {string} options.theme
 * @param {object} options.url
 * @returns {object[]}
 */
const getABTestList = ({ customer, order, theme, url }) => {
	// Declare the most common properties
	const country = customer.billing.country;
	const language = url.language;
	const locale = url.locale;
	const isAuthenticated = order.isAuthenticated;
	const isAvast = theme.brand === 'avast';
	const isIpm = theme.name === 'ipm';
	return [{
		customID: 'CART-2967',
		condition: ['en-au', 'en-us', 'en-ca', 'en-gb', 'de-de', 'fr-ca', 'fr-fr', 'es-ni'].includes(locale)
	}, {
		customID: 'CART-3170',
		condition: ['en-ca', 'fr-ca'].includes(locale) && country === 'CA'
	}, {
		customID: 'CART-3431'
	}, {
		customID: 'CART-3432',
		condition: ['en-us', 'en-ca', 'en-gb', 'en-au', 'de-de', 'fr-fr'].includes(locale)
	}, {
		customID: 'CART-3618',
		condition: theme.variables.isTaxIncluded
	}, {
		customID: 'CART-3785',
		condition: ['en-us', 'en-au', 'en-gb', 'en-ca', 'fr-fr'].includes(locale) && isAuthenticated
	}, {
		customID: 'CART-3988A',
		condition: language === 'en'
	}, {
		customID: 'CART-3988B',
		condition: language === 'en'
	}, {
		customID: 'CART-3988C',
		condition: language === 'en'
	}, {
		customID: 'CART-4095',
		condition: ['en-us', 'en-gb', 'en-au', 'en-ca', 'fr-ca', 'fr-fr', 'nl-nl', 'it-it', 'es-es'].includes(locale)
	}, {
		customID: 'CART-4550',
		condition: ['en-us', 'en-ca'].includes(locale) && isAuthenticated && (order.impressions.length > 0 || order.products.length > 1)
	}, {
		customID: 'CART-4669A'
	}, {
		customID: 'CART-4669B',
		condition: isAvast && isIpm
	}, {
		customID: 'CART-4669C',
		condition: isAvast && isIpm
	}, {
		customID: 'CART-5796A',
		condition: locale === 'en-us'
	}, {
		customID: 'CART-5796B',
		condition: locale === 'en-us'
	}
	];
};

/**
 * List of general customIDs
 * @returns {object[]}
 */
const getGeneralCustomIDs = () => {
	return [{
		customID: '1CLICKOFF' // Disable 1-click flow
	}, {
		customID: '1CLICKPAYPALOFF' // Disable PayPal in 1-click flow
	}, {
		customID: 'CLOSEOFFERNO' // Disable close offer
	}, {
		customID: 'COUNTRYOFF' // Disable country selector field
	}, {
		customID: 'CPNO' // Disable offer modal (cross-pop)
	}, {
		customID: 'DESCON' // Display extended product description
	}, {
		customID: 'PAYPALFIRST' // Move PayPal to the first place
	}, {
		customID: 'PAYPALOFF' // Disable PayPal
	}, {
		customID: 'PMSHOW' // Display all available payment methods
	}, {
		customID: 'PPMONTH' // Display monthly pricing
	}, {
		customID: 'UPON' // Offer up-sell product in the offer modal
	}, {
		customID: 'VSON' // Show variant selector
	}, {
		customID: 'PHONESHOW' // Show phone number field
	}, {
		customID: 'PAYCONIQ-SUCCESS' // Set a new total price so it ends up 000 (Payconiq success)
	}, {
		customID: 'PAYCONIQ-FAIL' // Set a new total price so it ends up 123 (Payconiq fail)
	}];
};

/**
 * List of full list of all customIDs (general + ab tests)
 * @param {string[]} customIDs
 * @param {object} options
 * @param {object} options.customID customID
 * @param {object} options.condition customID's condition
 * @returns {object[]}
 */
const getCustomIDsList = (customIDs, { customID, condition = true }) => ({
	customID,
	isActive: customIDs.includes(customID) && condition
});

/**
 * List of AB tests
 * @param {object} options
 * @param {object} options.customer
 * @param {object} options.order
 * @param {string} options.theme
 * @param {object} options.url
 * @returns {object[]}
 */
export default ({ customer, order, theme, url }) => {
	// General CustomIDs
	const generalCustomIDs = getGeneralCustomIDs();
	// List of AB Tests
	const abTests = getABTestList({
		customer,
		order,
		theme,
		url
	});
	// Return list of AB tests
	return [...generalCustomIDs, ...abTests]
		.map((customIDObject) => getCustomIDsList(order?.customIDs ?? [], customIDObject))
		.reduce((previous, abTest) => Object.assign({}, previous, {
			[abTest.customID]: abTest.isActive
		}), {});
};
